export interface ABTestConfig {
  test_name: string
  bPatternRatio: number // Bパターンの割合。100 - bPatternRatioがAパターンの割合になります
  keepSession: boolean // trueの場合、パターン値をCookieに保存。falseの場合、ストアのステートに保存
  startTime?: string
  endTime?: string
}

export const FOOTER_TAB_AB_TEST_NAME = 'FOOTER_TAB_AB_TEST'
// TODO: SIMILAR_EVENT_GROUP_AB_TESTとEVENT_DETAIL_TOAST_AB_TESTのテスト名の定義

export const SIMILAR_EVENT_GROUP_AB_TEST_CONFIG: ABTestConfig = {
  test_name: 'SIMILAR_EVENT_GROUP_AB_TEST',
  bPatternRatio: 0,
  keepSession: true,
  startTime: '2025-03-24 00:00:00'
}

export const EVENT_DETAIL_TOAST_AB_TEST_CONFIG: ABTestConfig = {
  test_name: 'EVENT_DETAIL_TOAST_AB_TEST',
  bPatternRatio: 50,
  keepSession: true,
  startTime: '2025-04-22 00:00:00',
  endTime: '2025-05-06 24:00:00'
}

// Add more ABTestConfig here if needed

export const FOOTER_TAB_AB_TEST_CONFIG: ABTestConfig = {
  test_name: FOOTER_TAB_AB_TEST_NAME,
  bPatternRatio: 30, // 30% B pattern (非表示), 70% A pattern (表示)
  keepSession: true,
  startTime: '2025-05-21 14:00:00',
  endTime: '2025-05-22 14:59:59'
}

export const ABTestConfigList: ABTestConfig[] = [
  SIMILAR_EVENT_GROUP_AB_TEST_CONFIG,
  EVENT_DETAIL_TOAST_AB_TEST_CONFIG,
  FOOTER_TAB_AB_TEST_CONFIG
  // Add more ABTestConfig here if needed
]
